import scraping from "./scraping.mp3";
import chemist from "./chemist.mp3";
import leo from "./leo.mp3";
import promise from "./promise.mp3";
import die from "./die.mp3";
import location from "./location.mp3";
import pain from "./pain.mp3";
import ronnie from "./ronnie.mp3";
import arny from "./arny.mp3";
import never from "./never.mp3";
import march from "./march.mp3";

// To do: intergrate sounds into database
const soundUrls = [
  scraping,
  location,
  "",
  "",
  ronnie,
  scraping,
  "",
  "",
  "",
  "",
  chemist,
  promise,
  "",
  die,
  "",
  leo,
  arny,
  pain,
  never,
  march,
];
export default soundUrls;
